import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { CONTACT } from "@/data/content";

const QUICK = [
  { label: "Home", href: "#home" }, { label: "About", href: "#about" },
  { label: "Services", href: "#services" }, { label: "Account Management", href: "#account-management" },
  { label: "Metering Services", href: "#metering" }, { label: "Request a Quote", href: "#quote" },
  { label: "Contact", href: "#contact" },
];

const SERVICES = [
  "Billing Disputes", "Municipal Account Management", "Metering Services", "Clearance Applications",
  "New Account Applications", "Refund Applications", "Account Closures",
];

export const Footer = () => (
  <footer className="relative bg-brand-dark grain text-white pt-20 pb-8 overflow-hidden">
    <div className="absolute inset-0 dot-grid opacity-[0.06]" />
    <div className="container mx-auto px-4 md:px-8 relative">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center">
            <img src="/logo-white.png" alt="SML Municipal Consulting" className="h-11 w-auto" />
          </div>
          <p className="mt-5 text-sm text-white/60 leading-relaxed max-w-xs">
            Professional Municipal Account Management & Utility Consulting across South Africa.
          </p>
          <p className="mt-5 text-sm font-medium text-secondary">Municipal Expertise. Professional Management. Less Stress.</p>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-white/80">Quick Links</h4>
          <ul className="mt-5 space-y-3">
            {QUICK.map((l) => (
              <li key={l.href}>
                <a href={l.href} data-testid={`footer-${l.href.slice(1)}`} className="text-sm text-white/60 hover:text-secondary transition-colors">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-white/80">Services</h4>
          <ul className="mt-5 space-y-3">
            {SERVICES.map((s) => (
              <li key={s}><a href="#services" className="text-sm text-white/60 hover:text-secondary transition-colors">{s}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-white/80">Contact</h4>
          <ul className="mt-5 space-y-4">
            <li>
              <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-3 text-sm text-white/70 hover:text-secondary transition-colors">
                <Phone className="w-4 h-4 text-secondary" /> {CONTACT.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} className="flex items-start gap-3 text-sm text-white/70 hover:text-secondary transition-colors break-all">
                <Mail className="w-4 h-4 text-secondary mt-0.5 shrink-0" /> {CONTACT.email}
              </a>
            </li>
            <li className="flex items-start gap-3 text-sm text-white/70">
              <MapPin className="w-4 h-4 text-secondary mt-0.5 shrink-0" />
              134 River Road, Barbeque Downs, Kyalami
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-white/50">© {new Date().getFullYear()} SML Municipal Consulting. All Rights Reserved.</p>
        <div className="flex items-center gap-6">
          <Link to="/privacy" data-testid="footer-privacy" className="text-xs text-white/50 hover:text-secondary transition-colors">Privacy Policy</Link>
          <Link to="/terms" data-testid="footer-terms" className="text-xs text-white/50 hover:text-secondary transition-colors">Terms & Conditions</Link>
        </div>
      </div>
    </div>
  </footer>
);
